import { Action, createReducer, on } from '@ngrx/store';
import { CompanyActions } from './company.actions';
import { companyInitialState, CompanyState } from './company.state';

const _companyReducer = createReducer(
  companyInitialState(),

  /**
   * Reducers For Clients
   */

  on(CompanyActions.getAllCompanies, (state) => {
    return {
      ...state,
      allCompanies: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.getAllCompaniesSuccess, (state, { companies }) => {
    return {
      ...state,
      allCompanies: {
        loading: false,
        data: companies.data,
      },
    };
  }),
  on(CompanyActions.getAllCompaniesFailure, (state, { failure }) => {
    return {
      ...state,
      allCompanies: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Company Details
   */
  on(CompanyActions.getCompanyById, (state) => {
    return {
      ...state,
      companyById: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.getCompanyByIdSuccess, (state, { company }) => {
    return {
      ...state,
      companyById: {
        loading: false,
        data: company.data,
      },
    };
  }),
  on(CompanyActions.getCompanyByIdFailure, (state, { failure }) => {
    return {
      ...state,
      companyById: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Update Company
   */
  on(CompanyActions.updateCompany, (state) => {
    return {
      ...state,
      updateCompany: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.updateCompanySuccess, (state, { response }) => {
    return {
      ...state,
      updateCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.updateCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      updateCompany: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Remove Member
   */
  on(CompanyActions.removeMember, (state) => {
    return {
      ...state,
      removeMember: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.removeMemberSuccess, (state, { response }) => {
    return {
      ...state,
      removeMember: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.removeMemberFailure, (state, { failure }) => {
    return {
      ...state,
      removeMember: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Member By Id
   */
  on(CompanyActions.getMemberById, (state) => {
    return {
      ...state,
      memberById: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.getMemberByIdSuccess, (state, { response }) => {
    return {
      ...state,
      memberById: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.getMemberByIdFailure, (state, { failure }) => {
    return {
      ...state,
      memberById: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Send Invoice
   */
  on(CompanyActions.sendInvoice, (state) => {
    return {
      ...state,
      sendInvoice: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.sendInvoiceSuccess, (state, { response }) => {
    return {
      ...state,
      sendInvoice: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.sendInvoiceFailure, (state, { failure }) => {
    return {
      ...state,
      sendInvoice: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Payment History
   */
  on(CompanyActions.paymentHistory, (state) => {
    return {
      ...state,
      paymentHistory: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.paymentHistorySuccess, (state, { response }) => {
    return {
      ...state,
      paymentHistory: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.paymentHistoryFailure, (state, { failure }) => {
    return {
      ...state,
      paymentHistory: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Add Company
   */
  on(CompanyActions.addCompany, (state) => {
    return {
      ...state,
      addCompany: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.addCompanySuccess, (state, { response }) => {
    return {
      ...state,
      addCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.addCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      addCompany: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Delete Company
   */
  on(CompanyActions.deleteCompany, (state) => {
    return {
      ...state,
      deleteCompany: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.deleteCompanySuccess, (state, { response }) => {
    return {
      ...state,
      deleteCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.deleteCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      deleteCompany: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Approver By Company Id
   */
  on(CompanyActions.approversByCompanyId, (state) => {
    return {
      ...state,
      approversByCompanyId: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.approversByCompanyIdSuccess, (state, { response }) => {
    return {
      ...state,
      approversByCompanyId: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.approversByCompanyIdFailure, (state, { failure }) => {
    return {
      ...state,
      approversByCompanyId: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Company Id
   */
  on(CompanyActions.contactCompany, (state) => {
    return {
      ...state,
      contactCompany: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.contactCompanySuccess, (state, { response }) => {
    return {
      ...state,
      contactCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.contactCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      contactCompany: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Company Id
   */
  on(CompanyActions.validateCompany, (state) => {
    return {
      ...state,
      validateCompany: {
        loading: true,
      },
    };
  }),
  on(CompanyActions.validateCompanySuccess, (state, { response }) => {
    return {
      ...state,
      validateCompany: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(CompanyActions.validateCompanyFailure, (state, { failure }) => {
    return {
      ...state,
      validateCompany: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function companyReducer(
  state: CompanyState | undefined,
  action: Action
) {
  return _companyReducer(state, action);
}
